import { render, staticRenderFns } from "./contentCourseLectureExamTagLevelDelete.vue?vue&type=template&id=1fb19ce5&"
import script from "./contentCourseLectureExamTagLevelDelete.vue?vue&type=script&lang=js&"
export * from "./contentCourseLectureExamTagLevelDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports